
import $ from 'jquery';
import 'magnific-popup';
import styles from '!style-loader/useable!css-loader!magnific-popup/dist/magnific-popup.css';

let loadedStyles = false;

/**
 * Create a lightbox
 * @param  {string} selector A jquery selector, such as '.event-image'
 * @param  {Object} options  Lightbox options
 * @return {void}
 */
export default function (selector, options) {
  if (!loadedStyles) {
    styles.use();
    loadedStyles = true
  }

  $(selector).magnificPopup(options);
}



// WEBPACK FOOTER //
// ./src/frontend/lightbox.js